module.exports = __webpack_public_path__ + "img/雄安新区地质大数据综合展示子系统.4cec93e6.jpg";